import { PrivateInterceptor } from '../../../Base/interceptors/PrivateInterceptor'


 // GET LISTADO DE ACCESO POR MENU
 export const getAccesosUser = async (idUser) => {
    const result = await PrivateInterceptor('IT/Users/Accesos/'+ idUser, 'GET');
    return result;
 }

// UPDATE LISTADO DE ACCESOS DE UN USUARIO
export const updateAccesoUser = async (data) => {
    const result = await PrivateInterceptor(`IT/Users/Accesos`, 'PUT', data);
    return result;
 }

 export const getPermisoCostosUser = async (idUser) => {
      const result = await PrivateInterceptor('IT/Users/PermisoCostos/'+ idUser, 'GET');
      return result;
 }
 export const getPermisoBotonesUser = async (idUser) => {
      const result = await PrivateInterceptor('IT/Users/PermisosBotones/'+ idUser, 'GET');
      return result;
 }

 /**
  * Obtiene todos los accesos de la tabla IPS.dbo.Acceso
  * @async
  * @function getAccesosTabla
  * @returns {Promise<Array>} Retorna un arreglo con todos los registros de accesos.
  * @example
  * const accesos = await getAccesosTabla();
  */
 export const getAccesosTabla = async () => {
     const result = await PrivateInterceptor('IT/Users/Accesos/accesosTabla', 'GET');
     return result;
 };

 /**
 * Guarda un nuevo acceso en la tabla de usuarios.
 * 
 * @async
 * @function saveAccesosTabla
 * @param {Object} accesoData - Objeto con los datos del acceso a guardar.
 * @param {string} accesoData.UserIPS - Nombre del usuario.
 * @param {string} accesoData.Password - Contraseña del usuario.
 * @param {string} accesoData.Windows - Nombre de usuario de Windows.
 * @returns {Promise<Object>} Retorna la respuesta del servidor indicando éxito o error.
 * @example
 * await saveAccesosTabla({ UserIPS: 'user1', Password: '1234', Windows: 'user1PC' });
 */
 export const saveAccesosTabla = async (accesoData) => {
     const result = await PrivateInterceptor(`IT/Users/Accesos/GuardarAcceso`, 'POST', accesoData);
     return result;
 };

 /**
 * Actualiza un acceso existente en la tabla de usuarios.
 * 
 * @async
 * @function updateAccesoTabla
 * @param {Object} accesoData - Objeto con los datos del acceso a actualizar.
 * @param {string} accesoData.UserIPS - Nombre del usuario.
 * @param {string} accesoData.Password - Contraseña actualizada.
 * @param {string} accesoData.Windows - Nombre de usuario de Windows actualizado.
 * @returns {Promise<Object>} Retorna la respuesta del servidor indicando éxito o error.
 * @example
 * await updateAccesoTabla({ UserIPS: 'user1', Password: '5678', Windows: 'user1PC' });
 */
 export const updateAccesoTabla = async (accesoData) => {
    const result = await PrivateInterceptor(`IT/Users/Accesos/ActualizarAcceso`, 'PUT', accesoData);
    return result;
 };

 
/**
 * Elimina un acceso de la tabla de usuarios.
 * 
 * @async
 * @function deleteAccesoTablaRow
 * @param {Object} accesoData - Objeto con el identificador del acceso a eliminar.
 * @param {number} accesoData.IdAcceso - Id del acceso a eliminar.
 * @returns {Promise<Object>} Retorna la respuesta del servidor indicando éxito o error.
 * @example
 * await deleteAccesoTablaRow({ IdAcceso: 512 });
 */
 export const deleteAccesoTablaRow = async (accesoData) => {
    const result = await PrivateInterceptor(`IT/Users/Accesos/EliminarAcceso`, 'DELETE', accesoData);
    return result;
 };
